__turbopack_context__.v({
  "appBar": "_5EqmxG_appBar",
  "compactContainer": "_5EqmxG_compactContainer",
  "container": "_5EqmxG_container",
  "displayName": "_5EqmxG_displayName",
  "logo": "_5EqmxG_logo",
  "navButton": "_5EqmxG_navButton",
});
